<template>
  <div class="crud-container" data-aos="fade-right">
    <div class="page-toolbar">
      <div>
        <h3 class="titulo-seccion m-0">Inventario</h3>
        <p class="subtitulo-seccion m-0">
          Módulo en construcción: aquí vivirá el nuevo motor de inventario.
        </p>
      </div>
    </div>

    <div class="divisan-card p-5 text-center">
      <i class="bi bi-boxes" style="font-size: 3rem; color: var(--d-green)"></i>
      <p class="text-cafe fw-bold mt-3 mb-0">Próximamente</p>
      <small class="text-muted-divisan">El nuevo módulo de inventario estará disponible en breve.</small>
    </div>
  </div>
</template>

<script setup></script>

<style scoped>
.page-toolbar {
  display: flex;
  align-items: center;
  gap: var(--d-space-3);
  min-height: 56px;
  box-sizing: border-box;
  background: var(--d-cream);
  border-bottom: 1px solid var(--d-border);
  margin: -2rem -2rem var(--d-space-5) -2rem;
  padding: var(--d-space-3) 2rem;
}
@media (max-width: 991.98px) {
  .page-toolbar {
    margin: -20px -1rem var(--d-space-4) -1rem;
    padding: var(--d-space-2) 1rem;
  }
}

.titulo-seccion {
  color: var(--d-brown);
  font-weight: 700;
  font-size: 1rem;
}
.subtitulo-seccion {
  color: var(--d-text-muted);
  font-size: 0.8rem;
  font-weight: 500;
}

.divisan-card {
  background-color: var(--d-cream);
  border-radius: 12px;
  border-left: 5px solid var(--d-green);
}
.text-cafe {
  color: var(--d-brown);
}
.text-muted-divisan {
  color: var(--d-text-muted);
  font-weight: 600;
}
</style>
